import { mappingApi, permissionsApi } from "@iventis/api/src/api";
import { DigitalTwinLicence } from "@iventis/domain-model/model/digitalTwinLicence";
import { User } from "@iventis/domain-model/model/user";

/**
 * Gets the current status of the unreal licence
 * @returns the current status of the unreal licence
 */
export const getDigitalTwinLicence = async (projectId: string, instanceId: string): Promise<DigitalTwinLicence> => {
    const { data } = await mappingApi.get<DigitalTwinLicence>(`projects/${projectId}/digital-twin/${instanceId}`);
    return data;
};

export const getAllDigitalTwinLicences = async (projectId: string): Promise<DigitalTwinLicence[]> => {
    const { data } = await mappingApi.get<DigitalTwinLicence[]>(`projects/${projectId}/digital-twin`);
    return data;
};

export const getUserById = async (userId: string): Promise<User> => {
    const response = await permissionsApi.get<User>(`users/${userId}`);
    return response.data;
};
